import { api } from 'shared/api'

import { ZendeskSchemas } from './schemas'

export const ZendeskApi = {
  sessionPageId: api.account.createPost({
    url: '/zendesk/dashboard/storeSessionInfo',
    schemas: ZendeskSchemas.sessionPageId,
  }),
}
